import Banner from "../../../components/common/Banner";
import Faqs from "../../../components/common/Faqs";
import Footer1 from "../../../components/footer/Footer1";
import Header1 from "../../../components/headers/Header1";
import Contact from "../../../components/otherPages/Contact";
import PageTitle2 from "../../../components/otherPages/PageTitle2";
import React from "react";
import MetaComponent from "../../../components/common/MetaComponent";

export default function ContactPage() {

  const [MetaTitle, setMetaTitle] = React.useState("Contact Us | AskMeRealty");
  const [MetaDescription, setMetaDescription] = React.useState("AskMeRealty - Contact us for any inquiries, support, or feedback. We're here to assist you with your real estate needs.");
  const [MetaKeywords, setMetaKeywords] = React.useState("Contact Us, AskMeRealty, Inquiries, Support, Feedback, Real Estate Assistance");
  const [MetaImage, setMetaImage] = React.useState("");

  const metadata = {
    title: MetaTitle,
    description: MetaDescription,
    keywords: MetaKeywords,
    url: window.location.href,
    siteName: "AskMeRealty",
    canonical: window.location.href,
    image: MetaImage,
  };

  return (
    <>
      <MetaComponent meta={metadata} />
      <Header1 />
      <PageTitle2 setMetaTitle={setMetaTitle} setMetaDescription={setMetaDescription} setMetaKeywords={setMetaKeywords} setMetaImage={setMetaImage} />
      <Contact />
      {/* <Faqs /> */}
      <Banner />
      <Footer1 />
    </>
  );
}
